export enum CourseParticipantType {
  Customer = "Customer",
  Employee = "Employee",
  Student = "Student",
}
